import { FunctionComponent } from 'react'

import {
  validCompetitorId,
  validMatchId,
  validTypeOfSport,
} from '@hooks/useRecentMatchOutcomes'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import RecentMatchOutcomesComponent from '@components/RecentMatchOutcomes'

type RecentMatchOutcomesProps = {
  title: string
  matchId?: string
  competitorId?: string
  typeOfSport: 'soccer'
}

const RecentMatchOutcomes: FunctionComponent<RecentMatchOutcomesProps> = ({
  title,
  typeOfSport,
  matchId,
  competitorId,
}) => {
  if (!validMatchId(matchId) && !validCompetitorId(competitorId)) {
    return null
  }
  if (!validTypeOfSport(typeOfSport)) {
    return null
  }

  if (!title) {
    return null
  }

  return (
    <RecentMatchOutcomesComponent
      title={title}
      typeOfSport={typeOfSport}
      matchId={matchId}
      competitorId={competitorId}
    />
  )
}

const widget = {
  kind: ['recent-match-outcomes'],
  component: RecentMatchOutcomes,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
